import { render, staticRenderFns } from "./DialogPatientSearch.vue?vue&type=template&id=53c585c0&scoped=true"
import script from "./DialogPatientSearch.vue?vue&type=script&lang=js"
export * from "./DialogPatientSearch.vue?vue&type=script&lang=js"
import style0 from "./DialogPatientSearch.vue?vue&type=style&index=0&id=53c585c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c585c0",
  null
  
)

export default component.exports